module.exports = __webpack_public_path__ + "img/ilustraciones_online.465a605d.svg";